export const readLocalStorageJson = (key: string) =>
  JSON.parse(localStorage.getItem(key) || "{}");

export const setLocalStorageJson = async (key: string, data: any) =>
  localStorage.setItem(key, JSON.stringify(data));


export const PROFILE_OWNER = "catalogOwner"